import React, { useState } from "react";
import "./style.css";
import backImage from "../../assets/images/IITGBackground.png"
import icon1 from "../../assets/images/icon1.png"
import icon2 from "../../assets/images/icon2.png"
import icon3 from "../../assets/images/icon3.png"
import icrageeLogo from "../../assets/images/icragee.png"
import Footer from "../../components/Footer/Footer";
import venueImage from "../../assets/images/venue.png"
import AboutCard from "../../components/AboutCard/AboutCard";
import auditoriumImage from "../../assets/images/auditorium.jpg"
import mapImage from "../../assets/images/map.png"
import Navbar from "../../components/Navbar/Navbar"
import Layout from "../../components/Layout/layout";
const Themes = () => {

    return (
        <Layout>
            <main className="bg-gray-100 mt-[5vw] pt-[25vw]">
                <div className="flex justify-center">
                    <div className="flex absolute md:mt-[-37vw] mt-[-45vw] md:flex-row flex-col items-center w-full justify-center gap-12">
                        <div className="text-[55px] text-white"
                            style={{ fontFamily: 'Bebas Neue', textShadow: '2px 1px 0px #000' }}
                        >
                            THEMES
                        </div>
                    </div>
                    <div className="w-full md:w-3/4 md:px-20 px-8 py-32 border-2 mb-10 bg-white md:mt-[-20vw] mt-[-15vw] text-justify">
                        <div className="font-bold text-2xl md:text-5xl text-sky-800 mb-10">
                            INSTRUCTIONS TO AUTHORS
                        </div>
                        <div className="text-xl md:text-3xl">
                            Authors are invited to submit abstracts (about 500 words) in MS-word by November 15, 2023 on the link given under “Submissions” on the conference website (<a href="https://event.iitg.ac.in/8icragee">https://event.iitg.ac.in/8icragee</a>). Abstract should indicate the Theme Number under which it falls, on the uppermost corner of the right-hand side. Title, name of author (s), and affiliations along with email addresses are must. Template for abstract can be downloaded from the website. Abstract should contain an introductory statement outlining the background and significance of the study, a succinct description of the basic methodologies used, a clear indication of the major findings of the study and a concluding statement. For final acceptance of the paper,registration of one of the authors is mandatory. All accepted full length papers will be published by Springer as Conference Proceedings.
                        </div>
                    </div>

                </div>
                <div className="flex justify-center">
                    <div className="w-full md:w-3/4 px-10 md:px-20 py-32 border-2 mb-20 bg-white">
                        <div className="font-bold text-2xl md:text-5xl text-sky-800 mb-10">
                            THEMES
                        </div>
                        <div className="flex flex-col gap-4 text-xl md:text-3xl">
                            <div>1. Field and laboratory testing of soils for the estimation of dynamic soil properties.</div>
                            <div>2. Latest findings on liquefaction of soils.</div>
                            <div>3. Seismic slope stability and landslides.</div>
                            <div>4. Seismic design of retaining walls, marine structures, and dams.</div>
                            <div>5. Seismic design of shallow and deep foundations.</div>
                            <div>6. Soil-structure interaction under dynamic loading.</div>
                            <div>7. Engineering seismology, strong ground motions.</div>
                            <div>8. Ground response analyses and local site effects.</div>
                            <div>9. Seismic hazard analyses: zonation, microzonation, risk assessment.</div>
                            <div>10. Ground improvement techniques including geosynthetics and reinforced earth for reduction of seismic hazard.</div>
                            <div>11. Role of building codes in reduction of seismic risk.</div>
                            <div>12. Wave propagation, engineering vibrations.</div>
                            <div>13. Vibration problems of high-speed railways.</div>
                            <div>14. Vibration absorption/isolation applications.</div>
                            <div>15. Performance of constructed facilities in extreme events/case histories of geotechnical earthquake engineering.</div>
                            <div>16. Reconnaissance reports of recent damaging earthquakes.</div>
                            <div>17. GIS and remote sensing, AI/ ML applications for geo-hazards.</div>
                            <div>18. Sensors and satellite technology for disaster management.</div>
                            <div>19. Seismic risk management and economics.</div>
                            <div>20. Community preparedness and pre-earthquake disaster management.</div>
                            <div>21. Innovative geotechnical applications in earthquake disaster management.</div>
                            <div>22. Earthquake engineering education.</div>
                            <div>23. Review of seismic design codes.</div>
                        </div>
                    </div>

                </div>

            </main>
        </Layout>
    );
}
export default Themes;